import { InputAdornment, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import "./feature.css";
import React from "react";

function FeatureSearch({
  featuresList,
  handleSearchChange,
  handleApiPathChange,
  handleOperationChange,
}) {
  return (
    <>
      {/* <Box className="Headercard" sx={{ width: '33%' }}>
        <Grid container spacing={3}>
          <Grid item xs>
            <Box className="Headercard_Total">
              <div className="Headercard_Total_text">
                <div className="org-para">
                  Total <br />Features
                </div>
                <div >
                  <span className="org-count">
                    {totalFeatures}
                  </span>
                </div>
              </div>
            </Box>
          </Grid>
        </Grid>
      </Box> */}

      <div>
        <div className="search-filter-wrapper">
          {/* TextField component for input */}
          <TextField
            size="small"
            id="search-access"
            label="Search"
            onChange={handleSearchChange}
            style={{ background: "rgba(242, 242, 243, 1)" }}
            variant="outlined" // Set variant to outlined
            // Add an icon to the end of the input field
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#000000"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-search"
                  >
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                  </svg>
                </InputAdornment>
              ),
            }}
            //  input label styles
            InputLabelProps={{
              style: { color: "black" },
            }}
            sx={{
              width: { xs: "100%", md: 320 },
            }}
          />

          <Box
            display="flex"
            gap={2}
            alignItems="center"
            flexWrap={{ xs: "wrap", md: "nowrap" }}
          >
            <FormControl
              size="small"
              style={{ background: "rgba(242, 242, 243, 1)", minWidth: 150 }}
            >
              <InputLabel id="api-path-dropdown" style={{ color: "black" }}>
                API Path
              </InputLabel>
              <Select
                labelId="api-path-dropdown"
                id="api-path-dropdown"
                label="API Path"
                onChange={handleApiPathChange}
              >
                <MenuItem value="All">All</MenuItem>
                {featuresList.map((path) => (
                  <MenuItem key={path.id} value={path.api_path}>
                    {path.api_path}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl
              size="small"
              style={{ background: "rgba(242, 242, 243, 1)", minWidth: 150 }}
            >
              <InputLabel id="operations-dropdown" style={{ color: "black" }}>
                Operations
              </InputLabel>
              <Select
                labelId="operations-dropdown"
                id="operations"
                label="Operations"
                onChange={handleOperationChange}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="GET">GET</MenuItem>
                <MenuItem value="POST">POST</MenuItem>
                <MenuItem value="PUT">PUT</MenuItem>
                <MenuItem value="DELETE">DELETE</MenuItem>
                <MenuItem value="PATCH">PATCH</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </div>
      </div>
    </>
  );
}

export default FeatureSearch;
